{
  "search": {
    "heading": "Find patient",
    "label": "Name, personnummer or reservnummer",
    "hint": "At least {minimum} characters. A personnummer may be written with or without a hyphen and with or without century digits.",
    "searching": "Searching …",
    "empty": "No patient in the record matches this search.",
    "failed": "The search could not be carried out.",
    "retry": "Try again",
    "tooLong": "The search text is too long. At most {maximum} characters.",
    "caption": "Search results, one row per patient.",
    "count": "{count, plural, =0 {No matches} one {# match} other {# matches}}",
    "truncated": "Showing the first {limit} matches. Narrow the search."
  },
  "column": {
    "name": "Name",
    "identifier": "Personnummer / reservnummer",
    "age": "Age",
    "location": "Location",
    "safety": "Alerts"
  },
  "location": {
    "notAdmitted": "Not admitted",
    "wardAndBed": "{ward} bed {bed}",
    "wardOnly": "{ward}, no bed"
  },
  "overview": {
    "back": "Back",
    "loading": "Loading the patient overview …",
    "failed": "The patient overview could not be loaded.",
    "notFound": "This patient is not in the record.",
    "retry": "Try again",
    "birthDate": "Born",
    "age": "Age",
    "sex": "Sex",
    "ward": "Ward",
    "location": "Location",
    "admitted": "Admitted",
    "responsible": "Responsible physician",
    "safetyHeading": "Safety information",
    "medicationsHeading": "Current medications",
    "notesHeading": "Latest notes",
    "noMedications": "No current medication orders in the record.",
    "noNotes": "No signed notes in the record.",
    "moreNotes": "Showing the {count} most recent notes. Older notes are in the record.",
    "readOnly": "New prescriptions and administration are not part of phase 0. The dosage of an existing order can be changed, allergies and safety flags documented, and notes written and signed."
  },
  "practitioner": {
    "notDocumented": "Not documented"
  },
  "identifier": {
    "personnummer": "Personnummer",
    "samordningsnummer": "Samordningsnummer",
    "reservnummer": "Reservnummer",
    "unknownSeries": "Unknown number series",
    "withAssigner": "{value} (issued by {assigner})",
    "none": "No identifier in the record"
  },
  "sex": {
    "male": "Male",
    "female": "Female",
    "other": "Other",
    "unknown": "Unknown"
  },
  "safety": {
    "allergies": "Allergies",
    "dnr": "DNR",
    "treatmentLimitation": "Treatment limitation",
    "isolation": "Isolation",
    "weight": "Weight",
    "infectionRisk": "Infection risk",
    "fallRisk": "Fall risk",
    "allergyStatusUnknown": "Allergy status not established",
    "other": "Other",
    "otherFlag": "{label}: {value}",
    "dnrNotDocumented": "None documented",
    "treatmentLimitationNotDocumented": "None documented",
    "isolationNotDocumented": "None documented",
    "weightNotDocumented": "No weight documented",
    "weightKg": "{weight} kg",
    "valueNotRecorded": "Documented without further detail",
    "isolationTypeNotRecorded": "type not recorded",
    "decidedBy": "Decided by {name}, {time}",
    "decidedByWithTitle": "Decided by {title} {name}, {time}"
  },
  "allergy": {
    "line": "{substance} ({qualifiers})",
    "lineWithReaction": "{substance} ({qualifiers}) — {reaction}",
    "substanceNotRecorded": "Substance not recorded",
    "severityMild": "mild",
    "severityModerate": "moderate",
    "severitySevere": "severe",
    "severityNotRecorded": "severity not recorded",
    "criticalityHigh": "high risk on re-exposure",
    "criticalityLow": "low risk on re-exposure",
    "criticalityUnableToAssess": "risk cannot be assessed",
    "unconfirmed": "unconfirmed",
    "resolved": "resolved"
  },
  "medication": {
    "caption": "Current medication orders, one row per order.",
    "columnSubstance": "Medication",
    "columnPreparation": "Preparation",
    "columnDose": "Dose",
    "columnRoute": "Route",
    "columnSchedule": "Schedule",
    "columnIndication": "Indication",
    "columnOrdered": "Ordered",
    "preparation": "{strength} {form}",
    "prn": "As needed, {frequency}. At most {maximum} per 24 hours.",
    "prnWithoutMaximum": "As needed, {frequency}. No 24-hour maximum documented.",
    "orderedBy": "Ordered by {name}",
    "endsAt": "Until {time}",
    "columnCorrect": "Change"
  },
  "notes": {
    "typeDaily": "Daily note",
    "typeAdmission": "Admission note",
    "typeDischarge": "Discharge note",
    "attribution": "{name}, {time}",
    "attributionWithTitle": "{title} {name}, {time}",
    "recordedLater": "Written into the record {time}",
    "amended": "Amended, version {version}",
    "otherLanguage": "Written in {language}",
    "subjective": "Subjective",
    "objective": "Objective",
    "assessment": "Assessment",
    "plan": "Plan"
  },
  "history": {
    "heading": "Versions of the patient details",
    "show": "Show all versions of the details",
    "hide": "Hide the versions of the details",
    "loading": "Reading versions …",
    "failed": "The versions could not be read.",
    "notFound": "The patient is not in the record.",
    "retry": "Try again",
    "count": "{count, plural, one {# version} other {# versions}}",
    "number": "Version {version}",
    "current": "Current version",
    "superseded": "Superseded by a later version",
    "retracted": "Marked as entered in error",
    "author": "{name}",
    "authorWithTitle": "{title} {name}",
    "written": "Written into the record {time}",
    "effective": "The details apply from {time}",
    "changed": "Changed in this version",
    "fieldStatus": "Status",
    "fieldIdentity": "Identity",
    "identityAssumed": "Assumed, not established",
    "identityEstablished": "Established",
    "statusActive": "Current",
    "statusInactive": "Not current",
    "statusRetracted": "Entered in error",
    "yes": "Yes",
    "no": "No"
  },
  "export": {
    "action": "Export (FHIR)",
    "working": "Exporting …",
    "refused": "Your role may not export the record.",
    "notFound": "The patient is not in the record.",
    "unavailable": "The export could not be fetched. Try again.",
    "notEncrypted": "The file is not encrypted. This version holds only made-up data."
  }
}
